module.exports = __webpack_public_path__ + "static/enquiry-loader-b2779bfb0cd450d84e08aa8079465efe.gif";